import { FlashcardDeckBuilder } from "@/components/Flashcards/FlashcardDeckBuilder"
import { PageShell } from "@/components/Layout"
import { useRouteBreadcrumbs } from "@/navigation/route-meta"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/flashcards/add")({
  component: AddFlashcardDeckPage,
})

function AddFlashcardDeckPage() {
  const breadcrumbs = useRouteBreadcrumbs("flashcards.index", [
    { label: "New Deck" },
  ])

  return (
    <PageShell title="New Flashcard Deck" breadcrumbs={breadcrumbs}>
      <FlashcardDeckBuilder mode="create" />
    </PageShell>
  )
}
